import { collections } from '@/mocks/home';

export default function Collections() {
  return (
    <section
      id="collections"
      className="scroll-mt-16 border-y border-secondary-200 bg-background-100"
    >
      <div className="mx-auto max-w-6xl px-4 py-10 md:px-6 md:py-14">
        <div className="flex flex-col items-start justify-between gap-3 md:flex-row md:items-end">
          <div>
            <span className="text-stamp text-xs text-primary-600">TOPIC ARCHIVE</span>
            <h3 className="font-heading mt-2 text-2xl font-black text-foreground-950 md:text-3xl">
              热门专题合集
            </h3>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              封面驱动的主题归档，每张大图背后都是一整套按顺序整理好的细节档案，
              点进来即可顺着索引查证。
            </p>
          </div>
          <a
            href="#index"
            className="whitespace-nowrap rounded-md border border-secondary-300 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-700 hover:border-primary-300 hover:text-primary-700"
          >
            按索引分区进入
            <i className="ri-arrow-right-line ml-1" />
          </a>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 md:mt-8 lg:grid-cols-3">
          {collections.map((c) => (
            <article
              key={c.code}
              className="group flex flex-col overflow-hidden rounded-lg border border-secondary-200 bg-background-50 transition-colors hover:border-primary-200"
            >
              <div className="relative h-44 w-full overflow-hidden">
                <img
                  src={c.cover}
                  alt={`${c.group} · ${c.title}`}
                  title={`${c.title} ${c.group}`}
                  className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-sm bg-foreground-950/70 px-2 py-1 text-xs font-medium text-background-100 backdrop-blur">
                  {c.group}
                </span>
                <span className="absolute bottom-3 left-3 inline-flex items-center gap-1 rounded-sm bg-primary-500 px-2 py-1 text-xs text-background-50">
                  <i className="ri-file-list-3-line" />
                  {c.count}
                </span>
              </div>

              <div className="flex flex-1 flex-col p-4">
                <p className="text-[11px] tracking-widest text-accent-700">{c.group} · {c.code}</p>
                <h4 className="mt-1 text-base font-bold text-foreground-950">
                  <a href="#timeline" className="block group-hover:text-primary-700">
                    {c.title}
                  </a>
                </h4>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{c.summary}</p>
                <div className="mt-4 flex items-center justify-between border-t border-secondary-200 pt-3">
                  <span className="whitespace-nowrap text-xs text-foreground-500">{c.items}</span>
                  <a
                    href="#timeline"
                    className="inline-flex items-center gap-1 whitespace-nowrap text-xs font-medium text-primary-600 hover:text-primary-700"
                  >
                    进入查证
                    <i className="ri-arrow-right-line" />
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}